const visibilityStatuses1 = {
    'VISIBLE': 'VISIBLE',
    'HIDDEN': "HIDDEN",
    "BLOCKED": "BLOCKED",
    "PAYMENT_PENDING": "PAYMENT_PENDING"
}

const visibilityStatuses = {
    'VISIBLE': 'פעיל',
    'HIDDEN': "מוסתר",
    "BLOCKED": "נעול",
    "PAYMENT_PENDING": "ממתין לתשלום"
}


const visibilityStatuseOptions = [
    { "id": visibilityStatuses1.VISIBLE, name: visibilityStatuses.VISIBLE },
    { "id": visibilityStatuses1.HIDDEN, name: visibilityStatuses.HIDDEN },
    { "id": visibilityStatuses1.BLOCKED, name: visibilityStatuses.BLOCKED },
    { "id": visibilityStatuses1.PAYMENT_PENDING, name: visibilityStatuses.PAYMENT_PENDING }
]




export { visibilityStatuses1, visibilityStatuseOptions, visibilityStatuses }